import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ExpenseRecordWidget from '../../../widgets/expenseRecordWidget/ExpenseRecordWidget'
import { getExpenses } from '../../../redux/actions/accountingExpenses'
import { sessionGetItemJSON } from '../../../utils/sessionHelpers'
//รายหารบันทึกจ่าย
export default function ExpenseRecord() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const voucherInfo = sessionGetItemJSON('voucherInfo')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let period = ''
      let id = ''
      if (periodInfo) {
        period = periodInfo.periodNumber || ''
      }
      if (voucherInfo) {
        id = voucherInfo.id || ''
      }
      const response = await getExpenses(projectCode, period, id)

      if (response) {
        setSchema(response.model)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpense>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <ExpenseRecordWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
